// extracted by mini-css-extract-plugin
export default {"base":"Modal_base__roG2P"};